const GetBudgetPageAction = {
	Request: 'GetBudgetPageActionRequest',
	Success: 'GetBudgetPageActionSuccess',
	Failure: 'GetBudgetPageActionFailure'
};

function getBudgetPage(year, type) {
	return {
		type: GetBudgetPageAction.Request,
		payload: {
			year,
			type
		}
	};
}

export const BudgetPageActionCreators = {
	getBudgetPage
};

export const BudgetPageActions = {
	GetBudgetPageAction
};
